export class DialogData {
  title?: string;
}
